import { Box, LinearProgress, Typography } from '@mui/material';
import { productionGames } from 'features/v2/presentation';
import { v2Tokens } from 'theme/v2Theme';

const GameLoadingPresentation = ({
  gameName,
  isCaptchaVerified,
  loadingProgression,
}) => {
  const activeGame = productionGames.find((game) => game.id === gameName);
  const gameTitle = activeGame ? activeGame.title : gameName;
  const loadingPercentage = Math.min(
    100,
    Math.max(0, Math.floor(loadingProgression * 100)),
  );

  return (
    <Box
      component="section"
      role="status"
      aria-live="polite"
      aria-label={
        isCaptchaVerified
          ? `Loading ${gameTitle}: ${loadingPercentage}%`
          : 'Captcha verification required'
      }
      sx={{
        width: 'min(100%, 620px)',
        mx: 'auto',
        mt: { xs: 4, md: 8 },
        p: { xs: 2.5, sm: 3 },
        color: 'text.primary',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: v2Tokens.radius.nested,
        backgroundColor: 'rgba(11,14,20,0.92)',
        boxShadow: '0 18px 45px rgba(0,0,0,0.28)',
        textAlign: 'left',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="overline" color="primary.main">
            {isCaptchaVerified ? 'Unity WebGL' : 'Security Check'}
          </Typography>
          <Typography
            component="h2"
            sx={{
              mt: 0.5,
              color: '#F3F4F6',
              fontSize: { xs: 16, sm: 18 },
              fontWeight: 600,
              lineHeight: 1.35,
            }}
          >
            {isCaptchaVerified
              ? `Loading ${gameTitle}`
              : 'Captcha verification required'}
          </Typography>
        </Box>

        {isCaptchaVerified && (
          <Typography
            className="v2-technical-label"
            color="primary.main"
            sx={{ flexShrink: 0, pt: 0.25, fontSize: { xs: 15, sm: 17 }, fontWeight: 800 }}
          >
            {loadingPercentage}%
          </Typography>
        )}
      </Box>

      <Typography
        color="text.secondary"
        sx={{ mt: 1, maxWidth: 520, fontSize: { xs: 12, sm: 13 }, lineHeight: 1.6 }}
      >
        {isCaptchaVerified
          ? 'Preparing the existing game module. Loading can take longer on mobile.'
          : 'Complete the verification below to continue to the game.'}
      </Typography>

      {isCaptchaVerified && (
        <LinearProgress
          variant="determinate"
          value={loadingPercentage}
          aria-label={`${gameTitle} loading progress`}
          sx={{
            mt: 2.5,
            height: 8,
            borderRadius: '4px',
            backgroundColor: 'rgba(255,255,255,0.08)',
            '& .MuiLinearProgress-bar': {
              borderRadius: '4px',
              backgroundColor: '#F7931A',
            },
          }}
        />
      )}
    </Box>
  );
};

export default GameLoadingPresentation;
